import React from 'react';

import Layout from '../Layout';

const WaterLayout: React.FC = () => {
  return (
    <Layout class="water"/>
  );
}

export default WaterLayout;